import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=f451eaf6&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Menu.vue?vue&type=style&index=1&id=f451eaf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f451eaf6",
  null
  
)

export default component.exports